import { render, staticRenderFns } from "./GuestReplyIcon.vue?vue&type=template&id=16944128"
import script from "./GuestReplyIcon.vue?vue&type=script&lang=js"
export * from "./GuestReplyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports